<template>
  <div class="preview-viewer preview-html-viewer">
    <div class="flash-container" id="webcad"></div>
    <PreviewWatermark
      v-if="previewInfo && previewInfo.statistic_info && previewInfo.statistic_info.watermark_info"
      :watermarkInfo="previewInfo.statistic_info.watermark_info"
    />
  </div>
</template>
<script>

import load from 'little-loader'
import { i18n } from '@/utils/i18n'
import { Toast } from 'vant'
import PreviewWatermark from './PreviewWatermark'

let gstarSDK
export default {
  name: 'CadViewer',
  components: {
    PreviewWatermark
  },
  props: {
    item: Object,
    previewInfo: Object
  },
  data () {
    return {
      staticUrl: process.env.ASSETS_URL ? process.env.ASSETS_URL : '/'
    }
  },
  mounted () {
    let { download_url, file_id } = this.previewInfo || {}
    this.fileId = file_id
    this.initGStar(download_url)
  },
  beforeDestroy () {
    if (gstarSDK) {
      gstarSDK.destroy()
      gstarSDK = null
    }
  },
  methods: {
    getDrawSheet (url, cb) {
      const req = window.XMLHttpRequest ? new window.XMLHttpRequest() : new window.ActiveXObject('Microsoft.XMLHTTP')
      gstarSDK.Tips.showProgress(0, i18n.t('base.prepareDownload'))
      req.onload = function () {
        if ((req.status >= 200 && req.status < 300) || req.status === 304) {
          cb(req.response)
        }
        if (req.status === 404) {
          cb(new Error(i18n.t('preview.fileNotFind')))
        }
      }
      req.open('GET', url, true)
      req.responseType = 'arraybuffer'
      req.send(null)
    },
    sizeLimitz () {
      Toast(i18n.t('preivew.fileTooLarge'))
    },
    getDrawSheetCB (arraybuffer) {
      gstarSDK.render('ocf', arraybuffer, this.fileId)
    },
    initGStar (url) {
      // 初始化cad
      const switchLayout = () => {
        this.getDrawSheet(url, this.getDrawSheetCB)
      }
      const secret = 'fldXImCGIwhP8ZQO4qecFY4ir2JxCc8bQUQ1ORrusA70H26qenVFScQPm3tMVFJ5'
      load(this.staticUrl + 'h5assets/GStarSDK.5.7.4.1.js', (res) => {
        let obj = {
          wrapId: 'webcad',
          switchLayoutCB: switchLayout,
          apiHost: window.location.host,
          tipsTime: 100 * 1024 * 1024,
          mobileSizeLimit: 10242880,
          sizeLimitCB: this.sizeLimit,
          language: 'zh'
        }
        gstarSDK = new window.GStarSDK(obj)
        // 增加密钥
        gstarSDK.setDynamicPW(secret)
        // 开启鼠标缩放功能
        gstarSDK.enableZoom(5)
        // 开启鼠标平移功能
        gstarSDK.enablePan()
        this.getDrawSheet(url, this.getDrawSheetCB)
      })
    }
  }
}
</script>
<style lang="postcss">
  .preview-html-viewer {
    background-color: #fff;
    & iframe {
      width: 100%;
      height: 100%;
      border: 0
    }
  }
  #webcad.flash-container{
    height: 100%;
  }

  .GStarSDK #GStarSDK-panel ul li:last-child {
      display: none;
  }
</style>
